import { render, staticRenderFns } from "./UserTagModal.vue?vue&type=template&id=db298b9a&"
import script from "./UserTagModal.vue?vue&type=script&lang=js&"
export * from "./UserTagModal.vue?vue&type=script&lang=js&"
import style0 from "./UserTagModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports